<template>
  <div id="app">
    <RequestsComponent>
      <template #loadRequestsData="loadRequestsData">
        <loader v-if="loadRequestsData.loader"/>
        <template v-else>
          <sidebar/>
          <div class="container-padding">
            <router-view />
          </div>
        </template> 
      </template>
    </RequestsComponent>
  </div>
</template>

<script>
import RequestsComponent from '@/components/StartRequests'
import Sidebar from '@/components/Sidebar'

export default {
  components: {
    Sidebar,
    RequestsComponent
  },
}
</script>
